import { flashList } from '@/mocks/home';

export default function FlashSection() {
  return (
    <section id="flash" className="mx-auto max-w-6xl scroll-mt-16 px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <span className="text-stamp text-xs text-primary-600">LIVE DOCKET</span>
          <h3 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
            今日实锤速递
          </h3>
          <p className="mt-2 max-w-lg text-sm text-foreground-600">
            按事件发生先后排出的滚动清单，任何新细节都会第一时间补在对应位次，不另起炉灶。
          </p>
        </div>
        <a
          href="#collections"
          className="whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
        >
          进入完整合集
          <i className="ri-arrow-right-line ml-1" />
        </a>
      </div>

      <div className="mt-6 grid gap-3 md:mt-8 md:grid-cols-2">
        {flashList.map((item) => (
          <article
            key={item.rank}
            className="group flex items-center gap-4 rounded-lg border border-secondary-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100"
          >
            <span
              className={`font-heading flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-xl font-black ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                    ? 'bg-accent-500 text-foreground-950'
                    : 'bg-secondary-100 text-foreground-600'
              }`}
            >
              {String(item.rank).padStart(2, '0')}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="whitespace-nowrap rounded-sm bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-800">
                  {item.tag}
                </span>
                {item.status === 'HOT' && (
                  <span className="whitespace-nowrap rounded-sm bg-primary-500 px-2 py-0.5 text-xs text-background-50">
                    HOT
                  </span>
                )}
                {item.status === 'NEW' && (
                  <span className="whitespace-nowrap rounded-sm bg-accent-500 px-2 py-0.5 text-xs text-foreground-950">
                    NEW
                  </span>
                )}
                <span className="ml-auto whitespace-nowrap text-xs text-foreground-400">{item.time}</span>
              </div>
              <h4 className="mt-2 truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                <a href="#timeline" className="block truncate">
                  {item.title}
                </a>
              </h4>
            </div>
            <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-500 sm:flex">
              <i className="ri-eye-line" />
              {item.heat}
            </span>
          </article>
        ))}

        <a
          href="#radar"
          className="group flex items-center gap-4 rounded-lg border border-dashed border-secondary-300 bg-secondary-50 p-4 transition-colors hover:border-primary-300 hover:bg-secondary-100"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-200 text-foreground-700">
            <i className="ri-flashlight-line text-xl" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-foreground-900">更新进行中</p>
            <p className="mt-1 text-xs text-foreground-500">
              当前有 26 个专题在深扒与核验，可到「更新雷达」看进度。
            </p>
          </div>
          <i className="ri-arrow-right-line text-lg text-foreground-400 group-hover:text-primary-600" />
        </a>
      </div>
    </section>
  );
}